import { Lightning } from '@lightningjs/sdk';
import { Theme } from '../../config/theme';
import { CmsConstants } from '../../Business/cms/CmsConstants';
import { Spinner } from '../shared/Spinner';

export class CmsRibbonDummy extends Lightning.Component {
  static _template() {
    return {
      x: 0,
      y: 0,
      w: w => w - CmsConstants.Ribbon.margin,
      color: Theme.Colors.Transparent,
      rect: true,
      SpinnerContainer: {
        w: w => w,
        h: h => h,
        color: 0xff800080,
        Spinner: {
          type: Spinner,
          x: w => w * 0.5,
          y: h => h * 0.5,
          mount: 0.5,
          visible: true,
        },
      },
    };
  }

  _firstActive() {
    this.signal('startLazyLoad');
  }
}
